import { StorageHlp } from 'src/lib/fliko/helpers/storage.helper';
import { FileInStorageHlp } from 'src/app/shared/helpers/file.helper';
import { FileInStorageVM } from 'src/app/shared/models/file.data';

export interface EditedImageVM extends FileInStorageVM {
  originalPath?: string;
}

export namespace EditedImageVM {
  export function fromPaths(storagePath: string | undefined, originalPath: string): EditedImageVM | null {
    return storagePath
      ? { storagePath, originalPath, name: StorageHlp.pathToName(storagePath) }
      : FileInStorageHlp.fromPath(originalPath);
  }
}

